export default __webpack_public_path__ + "static/Montserrat-SemiBold-184b691d5a3ccb8876e7666db0b08ba6.woff2";